unit SystemCostGroupDetailEdit;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.ExtCtrls,
  WEBLib.DBCtrls, WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmSystemCostGroupDetailEdit = class(TForm)
    WebPanel6: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    dblFleetTypes: TDBLookupComboBox;
    WebDBLookupComboBox2: TDBLookupComboBox;
    WebDBLookupComboBox3: TDBLookupComboBox;
    WebDBLookupComboBox4: TDBLookupComboBox;
    wcFleetTypes: TXDataWebClient;
    wdsFleetType: TXDataWebDataSet;
    wdsFleetTypeDescription: TStringField;
    wdsFleetTypeAutoNo: TIntegerField;
    dsFleetTypes: TDataSource;
    wcValueTypes: TXDataWebClient;
    wdsValueTypes: TXDataWebDataSet;
    wdsValueTypesAutoNo: TIntegerField;
    wdsValueTypesDescription: TStringField;
    dsValueTypes: TDataSource;
    wcSystemtypes: TXDataWebClient;
    wdsSystemTypes: TXDataWebDataSet;
    wdsSystemTypesDescription: TStringField;
    wdsSystemTypesSystemNO: TIntegerField;
    dsSystemTypes: TDataSource;
    wcGLAcounts: TXDataWebClient;
    wdsGLSystemAccounts: TXDataWebDataSet;
    wdsGLSystemAccountsGLCode: TIntegerField;
    wdsGLSystemAccountsGLDescription: TStringField;
    dsGLAccounts: TDataSource;
    wdsCDMaster: TXDataWebDataSet;
    dsCDMaster: TDataSource;
    wcCostingDetails: TXDataWebClient;
    wdsCostDetails: TXDataWebDataSet;
    wdsCostDetailsCostGroupMo: TIntegerField;
    wdsCostDetailsFleetType: TIntegerField;
    wdsCostDetailsValueType: TIntegerField;
    wdsCostDetailsSystemType: TIntegerField;
    wdsCostDetailsGLCode: TStringField;
    dsCostDetails: TDataSource;
    btnClose: TButton;
    btnPost: TButton;
    wcInfo: TXDataWebClient;
    procedure WebFormShow(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure btnPostClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
    iState2, iPrim : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemCostGroupDetailEdit: TfrmSystemCostGroupDetailEdit;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common;

procedure TfrmSystemCostGroupDetailEdit.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemCostGroupDetailEdit.btnPostClick(Sender: TObject);

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    wdsCostDetails.Cancel;
    Close;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage(Error.ErrorMessage);
  end;

begin
  Case iState2 of
    1 : begin
          wcInfo.RawInvoke('IstfmsSystemService.Put_CostGroups_Insert', [GetJsonFromDataSet(wdsCostDetails)],@OnSuccess, @OnError);
        end;
    2 : begin
          wcInfo.RawInvoke('IstfmsSystemService.Put_CostGroups_Edit', [GetJsonFromDataSet(wdsCostDetails)],@OnSuccess, @OnError);
        end;
  end;
end;

procedure TfrmSystemCostGroupDetailEdit.WebFormShow(Sender: TObject);

  procedure OnResultGLCode(Response : TXDataClientResponse);
    begin
      wdsGLSystemAccounts.Close;
      wdsGLSystemAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLSystemAccounts.Open;
    end;

  procedure OnResultSystem(Response : TXDataClientResponse);
    begin
      wdsSystemTypes.Close;
      wdsSystemTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemTypes.Open;

      wcGLAcounts.RawInvoke('IstfmsSystemService.Get_GLCode',[],@OnResultGLCode);
    end;

  procedure OnResultValue(Response : TXDataClientResponse);
    begin
      wdsValueTypes.Close;
      wdsValueTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsValueTypes.Open;

      wcSystemtypes.RawInvoke('IstfmsSystemService.Get_SystemTypes',[],@OnResultSystem);
    end;

  procedure OnResultFleet(Response : TXDataClientResponse);
    begin
      wdsFleetType.Close;
      wdsFleetType.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFleetType.Open;

      wcValueTypes.RawInvoke('IstfmsSystemService.Get_ValueTypes',[],@OnResultValue);
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsCostDetails.Close;
      wdsCostDetails.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostDetails.Open;

      wcFleetTypes.RawInvoke('IstfmsSystemService.Get_FleetTypes',[],@OnResultFleet);
    end;
begin
  wcCostingDetails.RawInvoke('IstfmsSystemService.Get_CostGroupDetails_View', [iPrim,0], @OnResult);

  Case iState2 of
    1 : Begin
          wdsCostDetails.Append;

        End;
    2 : Begin
          wdsCostDetails.Edit;

        End;

  End;
end;

procedure TfrmSystemCostGroupDetailEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel6 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  dblFleetTypes := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox2 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox3 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox4 := TDBLookupComboBox.Create(Self);
  btnClose := TButton.Create(Self);
  btnPost := TButton.Create(Self);
  wcFleetTypes := TXDataWebClient.Create(Self);
  wdsFleetType := TXDataWebDataSet.Create(Self);
  wdsFleetTypeDescription := TStringField.Create(Self);
  wdsFleetTypeAutoNo := TIntegerField.Create(Self);
  dsFleetTypes := TDataSource.Create(Self);
  wcValueTypes := TXDataWebClient.Create(Self);
  wdsValueTypes := TXDataWebDataSet.Create(Self);
  wdsValueTypesAutoNo := TIntegerField.Create(Self);
  wdsValueTypesDescription := TStringField.Create(Self);
  dsValueTypes := TDataSource.Create(Self);
  wcSystemtypes := TXDataWebClient.Create(Self);
  wdsSystemTypes := TXDataWebDataSet.Create(Self);
  wdsSystemTypesDescription := TStringField.Create(Self);
  wdsSystemTypesSystemNO := TIntegerField.Create(Self);
  dsSystemTypes := TDataSource.Create(Self);
  wcGLAcounts := TXDataWebClient.Create(Self);
  wdsGLSystemAccounts := TXDataWebDataSet.Create(Self);
  wdsGLSystemAccountsGLCode := TIntegerField.Create(Self);
  wdsGLSystemAccountsGLDescription := TStringField.Create(Self);
  dsGLAccounts := TDataSource.Create(Self);
  wdsCDMaster := TXDataWebDataSet.Create(Self);
  dsCDMaster := TDataSource.Create(Self);
  wcCostingDetails := TXDataWebClient.Create(Self);
  wdsCostDetails := TXDataWebDataSet.Create(Self);
  wdsCostDetailsCostGroupMo := TIntegerField.Create(Self);
  wdsCostDetailsFleetType := TIntegerField.Create(Self);
  wdsCostDetailsValueType := TIntegerField.Create(Self);
  wdsCostDetailsSystemType := TIntegerField.Create(Self);
  wdsCostDetailsGLCode := TStringField.Create(Self);
  dsCostDetails := TDataSource.Create(Self);
  wcInfo := TXDataWebClient.Create(Self);

  WebPanel6.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  dblFleetTypes.BeforeLoadDFMValues;
  WebDBLookupComboBox2.BeforeLoadDFMValues;
  WebDBLookupComboBox3.BeforeLoadDFMValues;
  WebDBLookupComboBox4.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnPost.BeforeLoadDFMValues;
  wcFleetTypes.BeforeLoadDFMValues;
  wdsFleetType.BeforeLoadDFMValues;
  wdsFleetTypeDescription.BeforeLoadDFMValues;
  wdsFleetTypeAutoNo.BeforeLoadDFMValues;
  dsFleetTypes.BeforeLoadDFMValues;
  wcValueTypes.BeforeLoadDFMValues;
  wdsValueTypes.BeforeLoadDFMValues;
  wdsValueTypesAutoNo.BeforeLoadDFMValues;
  wdsValueTypesDescription.BeforeLoadDFMValues;
  dsValueTypes.BeforeLoadDFMValues;
  wcSystemtypes.BeforeLoadDFMValues;
  wdsSystemTypes.BeforeLoadDFMValues;
  wdsSystemTypesDescription.BeforeLoadDFMValues;
  wdsSystemTypesSystemNO.BeforeLoadDFMValues;
  dsSystemTypes.BeforeLoadDFMValues;
  wcGLAcounts.BeforeLoadDFMValues;
  wdsGLSystemAccounts.BeforeLoadDFMValues;
  wdsGLSystemAccountsGLCode.BeforeLoadDFMValues;
  wdsGLSystemAccountsGLDescription.BeforeLoadDFMValues;
  dsGLAccounts.BeforeLoadDFMValues;
  wdsCDMaster.BeforeLoadDFMValues;
  dsCDMaster.BeforeLoadDFMValues;
  wcCostingDetails.BeforeLoadDFMValues;
  wdsCostDetails.BeforeLoadDFMValues;
  wdsCostDetailsCostGroupMo.BeforeLoadDFMValues;
  wdsCostDetailsFleetType.BeforeLoadDFMValues;
  wdsCostDetailsValueType.BeforeLoadDFMValues;
  wdsCostDetailsSystemType.BeforeLoadDFMValues;
  wdsCostDetailsGLCode.BeforeLoadDFMValues;
  dsCostDetails.BeforeLoadDFMValues;
  wcInfo.BeforeLoadDFMValues;
  try
    Name := 'frmSystemCostGroupDetailEdit';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 0;
    WebPanel6.Width := 640;
    WebPanel6.Height := 480;
    WebPanel6.Align := alClient;
    WebPanel6.ChildOrder := 10;
    WebPanel6.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanel6);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 187;
    WebLabel2.Top := 86;
    WebLabel2.Width := 54;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Fleet type:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel6);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 187;
    WebLabel3.Top := 157;
    WebLabel3.Width := 59;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Value Type:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel6);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 187;
    WebLabel4.Top := 230;
    WebLabel4.Width := 69;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'System Type:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel6);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 187;
    WebLabel5.Top := 308;
    WebLabel5.Width := 113;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'General Ledger Code:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    dblFleetTypes.SetParentComponent(WebPanel6);
    dblFleetTypes.Name := 'dblFleetTypes';
    dblFleetTypes.Left := 187;
    dblFleetTypes.Top := 112;
    dblFleetTypes.Width := 206;
    dblFleetTypes.Height := 22;
    dblFleetTypes.Color := clWhite;
    dblFleetTypes.HeightPercent := 100.000000000000000000;
    dblFleetTypes.WidthPercent := 100.000000000000000000;
    dblFleetTypes.DataField := 'FleetType';
    dblFleetTypes.DataSource := dsCostDetails;
    dblFleetTypes.KeyField := 'AutoNo';
    dblFleetTypes.ListField := 'Description';
    dblFleetTypes.ListSource := dsFleetTypes;
    WebDBLookupComboBox2.SetParentComponent(WebPanel6);
    WebDBLookupComboBox2.Name := 'WebDBLookupComboBox2';
    WebDBLookupComboBox2.Left := 187;
    WebDBLookupComboBox2.Top := 256;
    WebDBLookupComboBox2.Width := 206;
    WebDBLookupComboBox2.Height := 22;
    WebDBLookupComboBox2.Color := clWhite;
    WebDBLookupComboBox2.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox2.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox2.DataField := 'SystemType';
    WebDBLookupComboBox2.DataSource := dsCostDetails;
    WebDBLookupComboBox2.KeyField := 'SystemNO';
    WebDBLookupComboBox2.ListField := 'Description';
    WebDBLookupComboBox2.ListSource := dsSystemTypes;
    WebDBLookupComboBox3.SetParentComponent(WebPanel6);
    WebDBLookupComboBox3.Name := 'WebDBLookupComboBox3';
    WebDBLookupComboBox3.Left := 195;
    WebDBLookupComboBox3.Top := 178;
    WebDBLookupComboBox3.Width := 206;
    WebDBLookupComboBox3.Height := 22;
    WebDBLookupComboBox3.Color := clWhite;
    WebDBLookupComboBox3.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox3.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox3.DataField := 'ValueType';
    WebDBLookupComboBox3.DataSource := dsCostDetails;
    WebDBLookupComboBox3.KeyField := 'AutoNo';
    WebDBLookupComboBox3.ListField := 'Description';
    WebDBLookupComboBox3.ListSource := dsValueTypes;
    WebDBLookupComboBox4.SetParentComponent(WebPanel6);
    WebDBLookupComboBox4.Name := 'WebDBLookupComboBox4';
    WebDBLookupComboBox4.Left := 187;
    WebDBLookupComboBox4.Top := 334;
    WebDBLookupComboBox4.Width := 318;
    WebDBLookupComboBox4.Height := 22;
    WebDBLookupComboBox4.Color := clWhite;
    WebDBLookupComboBox4.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox4.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox4.DataField := 'GLCode';
    WebDBLookupComboBox4.DataSource := dsCostDetails;
    WebDBLookupComboBox4.KeyField := 'GLCode';
    WebDBLookupComboBox4.ListField := 'GLDescription';
    WebDBLookupComboBox4.ListSource := dsGLAccounts;
    btnClose.SetParentComponent(WebPanel6);
    btnClose.Name := 'btnClose';
    btnClose.Left := 480;
    btnClose.Top := 416;
    btnClose.Width := 96;
    btnClose.Height := 25;
    btnClose.Caption := 'btnClose';
    btnClose.ChildOrder := 8;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnPost.SetParentComponent(WebPanel6);
    btnPost.Name := 'btnPost';
    btnPost.Left := 360;
    btnPost.Top := 416;
    btnPost.Width := 96;
    btnPost.Height := 25;
    btnPost.Caption := 'Post';
    btnPost.ChildOrder := 9;
    btnPost.HeightPercent := 100.000000000000000000;
    btnPost.WidthPercent := 100.000000000000000000;
    SetEvent(btnPost, Self, 'OnClick', 'btnPostClick');
    wcFleetTypes.SetParentComponent(Self);
    wcFleetTypes.Name := 'wcFleetTypes';
    wcFleetTypes.Connection := dmData.dbConnect;
    wcFleetTypes.Left := 16;
    wcFleetTypes.Top := 100;
    wdsFleetType.SetParentComponent(Self);
    wdsFleetType.Name := 'wdsFleetType';
    wdsFleetType.Connection := dmData.dbConnect;
    wdsFleetType.Left := 80;
    wdsFleetType.Top := 101;
    wdsFleetTypeDescription.SetParentComponent(wdsFleetType);
    wdsFleetTypeDescription.Name := 'wdsFleetTypeDescription';
    wdsFleetTypeDescription.FieldName := 'Description';
    wdsFleetTypeAutoNo.SetParentComponent(wdsFleetType);
    wdsFleetTypeAutoNo.Name := 'wdsFleetTypeAutoNo';
    wdsFleetTypeAutoNo.FieldName := 'AutoNo';
    dsFleetTypes.SetParentComponent(Self);
    dsFleetTypes.Name := 'dsFleetTypes';
    dsFleetTypes.AutoEdit := False;
    dsFleetTypes.DataSet := wdsFleetType;
    dsFleetTypes.Left := 140;
    dsFleetTypes.Top := 101;
    wcValueTypes.SetParentComponent(Self);
    wcValueTypes.Name := 'wcValueTypes';
    wcValueTypes.Connection := dmData.dbConnect;
    wcValueTypes.Left := 48;
    wcValueTypes.Top := 176;
    wdsValueTypes.SetParentComponent(Self);
    wdsValueTypes.Name := 'wdsValueTypes';
    wdsValueTypes.Connection := dmData.dbConnect;
    wdsValueTypes.Left := 112;
    wdsValueTypes.Top := 173;
    wdsValueTypesAutoNo.SetParentComponent(wdsValueTypes);
    wdsValueTypesAutoNo.Name := 'wdsValueTypesAutoNo';
    wdsValueTypesAutoNo.FieldName := 'AutoNo';
    wdsValueTypesDescription.SetParentComponent(wdsValueTypes);
    wdsValueTypesDescription.Name := 'wdsValueTypesDescription';
    wdsValueTypesDescription.FieldName := 'Description';
    dsValueTypes.SetParentComponent(Self);
    dsValueTypes.Name := 'dsValueTypes';
    dsValueTypes.DataSet := wdsValueTypes;
    dsValueTypes.Left := 152;
    dsValueTypes.Top := 173;
    wcSystemtypes.SetParentComponent(Self);
    wcSystemtypes.Name := 'wcSystemtypes';
    wcSystemtypes.Connection := dmData.dbConnect;
    wcSystemtypes.Left := 32;
    wcSystemtypes.Top := 248;
    wdsSystemTypes.SetParentComponent(Self);
    wdsSystemTypes.Name := 'wdsSystemTypes';
    wdsSystemTypes.Connection := dmData.dbConnect;
    wdsSystemTypes.Left := 88;
    wdsSystemTypes.Top := 245;
    wdsSystemTypesDescription.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesDescription.Name := 'wdsSystemTypesDescription';
    wdsSystemTypesDescription.FieldName := 'Description';
    wdsSystemTypesSystemNO.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesSystemNO.Name := 'wdsSystemTypesSystemNO';
    wdsSystemTypesSystemNO.FieldKind := fkCalculated;
    wdsSystemTypesSystemNO.FieldName := 'SystemNO';
    wdsSystemTypesSystemNO.Calculated := True;
    dsSystemTypes.SetParentComponent(Self);
    dsSystemTypes.Name := 'dsSystemTypes';
    dsSystemTypes.DataSet := wdsSystemTypes;
    dsSystemTypes.Left := 132;
    dsSystemTypes.Top := 245;
    wcGLAcounts.SetParentComponent(Self);
    wcGLAcounts.Name := 'wcGLAcounts';
    wcGLAcounts.Connection := dmData.dbConnect;
    wcGLAcounts.Left := 24;
    wcGLAcounts.Top := 324;
    wdsGLSystemAccounts.SetParentComponent(Self);
    wdsGLSystemAccounts.Name := 'wdsGLSystemAccounts';
    wdsGLSystemAccounts.Connection := dmData.dbConnect;
    wdsGLSystemAccounts.Left := 104;
    wdsGLSystemAccounts.Top := 332;
    wdsGLSystemAccountsGLCode.SetParentComponent(wdsGLSystemAccounts);
    wdsGLSystemAccountsGLCode.Name := 'wdsGLSystemAccountsGLCode';
    wdsGLSystemAccountsGLCode.FieldName := 'GLCode';
    wdsGLSystemAccountsGLDescription.SetParentComponent(wdsGLSystemAccounts);
    wdsGLSystemAccountsGLDescription.Name := 'wdsGLSystemAccountsGLDescription';
    wdsGLSystemAccountsGLDescription.FieldName := 'GLDescription';
    dsGLAccounts.SetParentComponent(Self);
    dsGLAccounts.Name := 'dsGLAccounts';
    dsGLAccounts.DataSet := wdsGLSystemAccounts;
    dsGLAccounts.Left := 148;
    dsGLAccounts.Top := 332;
    wdsCDMaster.SetParentComponent(Self);
    wdsCDMaster.Name := 'wdsCDMaster';
    wdsCDMaster.Connection := dmData.dbConnect;
    wdsCDMaster.Left := 76;
    wdsCDMaster.Top := 420;
    dsCDMaster.SetParentComponent(Self);
    dsCDMaster.Name := 'dsCDMaster';
    dsCDMaster.DataSet := wdsCDMaster;
    dsCDMaster.Left := 156;
    dsCDMaster.Top := 420;
    wcCostingDetails.SetParentComponent(Self);
    wcCostingDetails.Name := 'wcCostingDetails';
    wcCostingDetails.Connection := dmData.dbConnect;
    wcCostingDetails.Left := 312;
    wcCostingDetails.Top := 40;
    wdsCostDetails.SetParentComponent(Self);
    wdsCostDetails.Name := 'wdsCostDetails';
    wdsCostDetails.Connection := dmData.dbConnect;
    wdsCostDetails.Left := 416;
    wdsCostDetails.Top := 39;
    wdsCostDetailsCostGroupMo.SetParentComponent(wdsCostDetails);
    wdsCostDetailsCostGroupMo.Name := 'wdsCostDetailsCostGroupMo';
    wdsCostDetailsCostGroupMo.FieldName := 'CostGroupMo';
    wdsCostDetailsFleetType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsFleetType.Name := 'wdsCostDetailsFleetType';
    wdsCostDetailsFleetType.FieldName := 'FleetType';
    wdsCostDetailsValueType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsValueType.Name := 'wdsCostDetailsValueType';
    wdsCostDetailsValueType.FieldName := 'ValueType';
    wdsCostDetailsSystemType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsSystemType.Name := 'wdsCostDetailsSystemType';
    wdsCostDetailsSystemType.FieldName := 'SystemType';
    wdsCostDetailsGLCode.SetParentComponent(wdsCostDetails);
    wdsCostDetailsGLCode.Name := 'wdsCostDetailsGLCode';
    wdsCostDetailsGLCode.FieldName := 'GLCode';
    dsCostDetails.SetParentComponent(Self);
    dsCostDetails.Name := 'dsCostDetails';
    dsCostDetails.AutoEdit := False;
    dsCostDetails.DataSet := wdsCostDetails;
    dsCostDetails.Left := 528;
    dsCostDetails.Top := 40;
    wcInfo.SetParentComponent(Self);
    wcInfo.Name := 'wcInfo';
    wcInfo.Connection := dmData.dbConnect;
    wcInfo.Left := 448;
    wcInfo.Top := 208;
  finally
    WebPanel6.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    dblFleetTypes.AfterLoadDFMValues;
    WebDBLookupComboBox2.AfterLoadDFMValues;
    WebDBLookupComboBox3.AfterLoadDFMValues;
    WebDBLookupComboBox4.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnPost.AfterLoadDFMValues;
    wcFleetTypes.AfterLoadDFMValues;
    wdsFleetType.AfterLoadDFMValues;
    wdsFleetTypeDescription.AfterLoadDFMValues;
    wdsFleetTypeAutoNo.AfterLoadDFMValues;
    dsFleetTypes.AfterLoadDFMValues;
    wcValueTypes.AfterLoadDFMValues;
    wdsValueTypes.AfterLoadDFMValues;
    wdsValueTypesAutoNo.AfterLoadDFMValues;
    wdsValueTypesDescription.AfterLoadDFMValues;
    dsValueTypes.AfterLoadDFMValues;
    wcSystemtypes.AfterLoadDFMValues;
    wdsSystemTypes.AfterLoadDFMValues;
    wdsSystemTypesDescription.AfterLoadDFMValues;
    wdsSystemTypesSystemNO.AfterLoadDFMValues;
    dsSystemTypes.AfterLoadDFMValues;
    wcGLAcounts.AfterLoadDFMValues;
    wdsGLSystemAccounts.AfterLoadDFMValues;
    wdsGLSystemAccountsGLCode.AfterLoadDFMValues;
    wdsGLSystemAccountsGLDescription.AfterLoadDFMValues;
    dsGLAccounts.AfterLoadDFMValues;
    wdsCDMaster.AfterLoadDFMValues;
    dsCDMaster.AfterLoadDFMValues;
    wcCostingDetails.AfterLoadDFMValues;
    wdsCostDetails.AfterLoadDFMValues;
    wdsCostDetailsCostGroupMo.AfterLoadDFMValues;
    wdsCostDetailsFleetType.AfterLoadDFMValues;
    wdsCostDetailsValueType.AfterLoadDFMValues;
    wdsCostDetailsSystemType.AfterLoadDFMValues;
    wdsCostDetailsGLCode.AfterLoadDFMValues;
    dsCostDetails.AfterLoadDFMValues;
    wcInfo.AfterLoadDFMValues;
  end;
end;

end.